module.exports = __webpack_public_path__ + "img/矩形 151@3x.b23fa613.png";